import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import * as Cookies from "es-cookie";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import { Row, Col,Container,} from 'react-bootstrap';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import moment from 'moment';
import { withRouter, Link } from "react-router-dom";
import GatePassSection from "../components/gatePass/gatePassSection";

const FETCH_PARENT_PERMISSION_DETAILS = gql`
query($institute_id: Int!) {
    getParentsPermissionDetails(institute_id: $institute_id) {
        class_id
        exam_id
        roll_no
        branch_id
        section_id
        class_name
        exam_name
        branch_name
        section_name
        student_name
        student_mobile
        request_date
        from_datetime
        to_datetime
        receiver_name
        receiver_mobile
        request_message
        receiver_image_path
        parent_name
        parent_mobile
        permission_status
        comments
        approved_by
        approved_time
        outtime
        outtime_image_path
        outtime_inserted_by
        intime
        intime_image_path
        intime_inserted_by
        permission_id
    }
}
`
const FETCH_ORGANISATION_DETAILS = gql`
query($institution_id: Int!) {
  getOrganisationProfile(institution_id: $institution_id){
      id
      organisation_name
      chairman
      contact_no
      complete_address
      region_id
      logo
      hod
      hod_mobile
      principal
      principal_mobile
      vice_principal
      vice_principal_mobile
      timestamp
  }
}
`


class GatePass extends Component {

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  }

  render() {
    const getParentsPermissionDetails = this.props.getParentsPermissionDetails;
    const loading = getParentsPermissionDetails.loading;
    const error = getParentsPermissionDetails.error;




    if (error !== undefined) {
      alert("Server Error. " + error.message);
      return null;
    }

    const getOrganisationProfile = this.props.getOrganisationProfile;
    const loading3 = getOrganisationProfile.loading;
    const error3 = getOrganisationProfile.error;

    if (error3 !== undefined) {
      alert("Server Error. " + error3.message);
      return null;
    }


    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
            {
              loading || loading3 ?
                (
                  <Container>
                    <Row>
                      <Col sm={12}>
                        <div class="spinner-border text-primary text-center loading-img-center"></div>
                      </Col>
                    </Row>
                  </Container>
                )
                :
                (
                  <GatePassSection getParentsPermissionDetails={getParentsPermissionDetails.getParentsPermissionDetails}
                    getOrganisationProfile={this.props.getOrganisationProfile.getOrganisationProfile}
                  />
                )
            }

          </div>
        </div>
      </div>

    )
  }
}
export default withRouter(compose(
  graphql(FETCH_PARENT_PERMISSION_DETAILS, {
    options: (props) => ({
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
      },
    }),
    name: "getParentsPermissionDetails",
  }),
  graphql(FETCH_ORGANISATION_DETAILS, {
    options: (props) => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid"))
      },

    }), name: "getOrganisationProfile"
  }),
)(GatePass));


//  export default GatePass;